export default "__VITE_ASSET__b2e8f71d__"